import { render } from "./AcessoNegado.vue?vue&type=template&id=902e178a&scoped=true"
import script from "./AcessoNegado.vue?vue&type=script&lang=js"
export * from "./AcessoNegado.vue?vue&type=script&lang=js"

import "./AcessoNegado.vue?vue&type=style&index=0&id=902e178a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-902e178a"]])

export default __exports__